<template>
  <div v-if="validationErrors">
    <ul class="alert">
      <li v-for="(value, key, index) in validationErrors" v-bind:key="index">
        {{ value }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["errors"],
  data() {
    return {
      isOpen: this.errors
    };
  },
  computed: {
    validationErrors: function() {
      let errors = Object.values(this.errors);
      errors = errors.flat();
      return errors;
    }
  }
};
</script>

<style scoped>
/* The alert message box */
.alert {
  padding: 20px;
  background-color: rgba(244, 67, 54, 0.7); /* Red */
  color: white;
  margin-bottom: 15px;
  margin-top: 15px;
  border-radius: 10px;
}
.alert > li {
  color: white;
  list-style-type: none;
}

/* The close button */
.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

/* When moving the mouse over the close button */
.closebtn:hover {
  color: black;
}
</style>
